export const CHANGE_FILTER      = "CHANGE_FILTER";
export const CHANGE_DATALIST    = "CHANGE_DATALIST";
export const CHANGE_MUTEX       = "CHANGE_MUTEX";
export const CHANGE_VALUES      = "CHANGE_VALUES";
export const SET_INITIAL_STATE  = "SET_INITIAL_STATE";
export const SET_NEW_URL_STATE  = "SET_NEW_URL_STATE";
export const CHANGE_MARCA       = "CHANGE_MARCA";
export const RESET_APPLICATION  = "RESET_APPLICATION";
